export function requiredValidation(err = "Campo requerido") {
  return (v) => !!v || err;
}
